// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { OpenBidOrderModel } from "@steiner/App/Store/Reducers";

const openBidsUrl = "/api/str/OpenBids";

export interface OpenBidsApiParameter extends ApiParameter, HasPagingParameters {
    customerSequence?: string;
    orderNumber?: string;
    releaseNumber?: string;
    toDate?: string;
    fromDate?: string;
    poNumber?: string;
}

export interface GetOpenBidDetailsApiParameter extends ApiParameter, HasPagingParameters {
    orderNumber?: string;
    generationId?: string;
}

export interface DeclineBidApiParameter extends ApiParameter, HasPagingParameters {
    OrderNumber?: string;
    GenerationId?: string;
    Company?: string;
    DateSubmitted?: string;
    CustomerNotes?: string;
}

export interface OpenBidsModel extends HasPagingParameters {
    openOrderItemList?: OpenBidOrderModel[];
    pagination: PaginationModel | null;
}

export async function getOpenBids(parameter: OpenBidsApiParameter): Promise<OpenBidsModel> {
    const openBids = await get<OpenBidsModel>(`${openBidsUrl}/Items`, parameter);
    return openBids;
}

export async function getOpenBidDetails(parameter: GetOpenBidDetailsApiParameter): Promise<any> {
    const result = await get<any>(`${openBidsUrl}/Item`, parameter);
    return result;
}

export async function sendDeclineBidNotification(parameter: DeclineBidApiParameter): Promise<any> {
    const result = await get<any>(`${openBidsUrl}/DeclineBid`, parameter);
    return result;
}
